import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import React from 'react'

import Button from '@/app/component/atom/button'
import Dialog from '@/app/component/atom/dialog'
import DialogHeader from '@/app/component/atom/dialog/header'
import CampaignSelect from '@/app/module/campaigns/component/campaign-select'
import { Q_ACTIONS } from '@/app/module/campaigns/definitions'
import { LocalReopenAction } from '@/app/module/campaigns/types'

type Props = {
  value: LocalReopenAction

  onClose: () => void
  onSave: (value: Pick<LocalReopenAction, 'reopen'>) => void
}

const Reopen: React.FC<Props> = ({ value, onClose, onSave }) => {
  const [campId, setCampId] = React.useState(value.reopen.campId)

  return (
    <Dialog open onClose={onClose}>
      <DialogHeader
        closeButtonLabel="Close"
        icon={Q_ACTIONS.reopen.icon}
        title={Q_ACTIONS.reopen.label}
        onClose={onClose}
      />
      <DialogContent>
        <ContentContainer>
          <CampaignSelect value={campId} onChange={setCampId} />
        </ContentContainer>
      </DialogContent>
      <DialogActions>
        <Button disabled={!campId} variant="contained" onClick={() => onSave({ reopen: { campId } })}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const ContentContainer = ({ children }: { children: React.ReactNode }) => (
  <div style={{ maxWidth: '100%', minWidth: '300px', paddingTop: 8, width: '80vw' }}>{children}</div>
)

export default Reopen

export type { Props as ReopenProps }
